module.exports = __webpack_public_path__ + "static/media/clodify.54eadd8e.svg";